// extracted by mini-css-extract-plugin
module.exports = {"title":"l_r","cards":"l_s"};